import { Link, useLocation } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";

export default function PublicHeader() {
  const loc = useLocation();
  const items = [
    { to: "/", label: "Home" },
    { to: "/rooms", label: "Suites" },
    { to: "/amenities", label: "Amenities" },
    { to: "/gallery", label: "Gallery" },
    { to: "/attractions", label: "Explore" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
  ];
  return (
    <header className="sticky top-0 z-50" style={{ background: "rgba(253,251,247,.82)", backdropFilter: "blur(16px)", borderBottom: "1px solid var(--border)" }}>
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-8 py-4">
        <Link to="/" data-testid="public-header-logo" className="flex items-center">
          <BrandLogo className="h-9 md:h-11 w-auto" />
        </Link>
        <nav className="hidden md:flex items-center gap-7">
          {items.map((i) => (
            <Link key={i.to} to={i.to} data-testid={`public-nav-${i.label.toLowerCase()}`}
              className="text-sm font-medium transition-colors"
              style={{ color: loc.pathname === i.to ? "var(--terracotta)" : "var(--fg)" }}>{i.label}</Link>
          ))}
        </nav>
        <Link to="/availability" data-testid="public-header-book-button" className="btn-primary text-sm">Book Your Stay</Link>
      </div>
    </header>
  );
}
